import * as React from 'react'
import { Link } from 'react-router-dom'

import Text from '../Text'
import { ColorInText } from '../theme/colors'

interface Props {
  text: string
  color: ColorInText
  link?: string
  onClick?: (event) => void
}

class LinkText extends React.Component<Props> {
  handleClick = event => {
    if (this.props.onClick) {
      this.props.onClick(event)
      return false
    }
  }

  render() {
    const { text, link, color } = this.props
    return (
      <a href={link} onClick={this.handleClick} style={{ cursor: 'pointer' }}>
        <Text as="span" size="s" color={color} underline>
          {text}
        </Text>
      </a>
    )
  }
}
export default LinkText
